export default "/credits/business/assets/ee48afd26ef7026344591ff9d2649256.png";